'use client'

import BannerComponent from '../banner'
import {Banner} from '../types'
import React from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import styled from 'styled-components'
import theme, {media} from '@/src/config/theme'
import {ChevronLeft, ChevronRight} from 'lucide-react'

export const MainPageBanner = ({banners}: {banners: Banner[]}) => {
  const settings = {
    infinite: true,
    // speed: 2000,
    autoplay: process.env.NODE_ENV === 'production',
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,

    dots: false,
    draggable: false,
    // fade: true,
    waitForAnimate: false,
    adaptiveHeight: true,

    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />,
  }

  return (
    <Wrapper className="slider-container">
      <Slider {...settings}>
        {banners.map(banner => (
          <BannerComponent banner={banner} key={banner.id} />
        ))}
      </Slider>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;

  .slick-track {
    background: ${theme.colors.bgDark};
  }

  .slick-dots {
    padding-top: 15px;
    padding-bottom: 15px;
    bottom: 45px;
    position: static;
    background: ${theme.colors.bgDark};

    li {
      width: unset;
      height: unset;

      &.slick-active {
        button {
          border: solid 1px white;
        }
      }

      button {
        width: 40px;
        height: 40px;
        padding: 16px;
        display: flex;
        border-radius: 16px;

        &:before {
          width: unset;
          height: unset;
          position: relative;
          color: white;
          opacity: 0.75;
          align-self: center;
          justify-self: center;
          font-size: 8px;
        }
      }
    }
  }

  .slick-prev {
    left: 25px;
    z-index: 1;
    color: white;
    width: initial;

    &:hover {
      color: white;
    }
  }

  .slick-next {
    right: 25px;
    z-index: 1;
    color: white;
    width: initial;

    &:hover {
      color: white;
    }
  }

  .slick-disabled {
    opacity: 0.25;
  }

  @media ${media.sm} {
    .slick-dots {
      padding-bottom: unset;
      padding-top: unset;
      position: absolute;
      background: transparent;
    }
  }
`

const ArrowLeft = (props: any) => {
  return (
    <ChevronLeft
      className={props.className}
      data-arrow-right="1"
      onClick={props.onClick}
      size={42}
    />
  )
}

const ArrowRight = (props: any) => {
  return (
    <ChevronRight
      className={props.className}
      data-arrow-left="1"
      onClick={props.onClick}
      size={42}
    />
  )
}
